<template>
  <a-modal
    v-model:open="visible"
    :title="title"
    width="860px"
    :footer="null"
    destroy-on-close
    class="policy-preview-modal"
    @cancel="handleClose"
  >
    <iframe v-if="url" :src="url" class="policy-iframe" title="policy preview"></iframe>
  </a-modal>
</template>

<script setup>
import { ref } from "vue";

const visible = ref(false);
const title = ref("");
const url = ref("");

function open(options) {
  title.value = options.title || "文件预览";
  url.value = options.url || "";
  visible.value = true;
}

function handleClose() {
  visible.value = false;
  url.value = "";
}

defineExpose({ open });
</script>

<style lang="scss">
.policy-preview-modal {
  .ant-modal-body {
    padding: 0;
  }
}

.policy-iframe {
  display: block;
  width: 100%;
  height: 72vh;
  border: none;
  background: #f5f5f5;
}
</style>
